/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import InvitationsTable from './InvitationsTable';
import InviteUserDialog from './InviteUserDialog';

export default function Invitations() {
    return (
        <div className="flex flex-col mt-10">
            <div className="flex flex-row justify-between items-center space-x-4">
                <p className="text-sm w-3/4">
                    This will send an invitation to create an account to the email address you enter.
                </p>
                <div className="flex flex-row space-x-4 w-auto">
                    <InviteUserDialog />
                </div>
            </div>
            <InvitationsTable />
        </div>
    );
}
